import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BcitiTabsComponent } from 'src/app/global/components/common/tabs/tabs.component';
import { Request } from '../../models/request.model';

@Component({
    selector: 'app-request-infos-panel',
    templateUrl: './request-infos-panel.component.html',
    styleUrls: ['./request-infos-panel.component.scss'],
})
export class RequestInfosPanelComponent {
    @ViewChild(BcitiTabsComponent) bcitiTabs: BcitiTabsComponent;

    @Input() request: Request;
    @Input() canEdit: boolean = false;
    @Input() isPolling: boolean = false;

    @Output() requestChanged = new EventEmitter<Request>();
    @Output() messagesTabActivated = new EventEmitter<void>();
    @Output() infosTabActivated = new EventEmitter<void>();

    private lastActiveTabIndex = 0;

    get hasUnreadMessages(): boolean {
        return (this.request?.adminUnreadMessageCount ?? 0) > 0;
    }

    detectActiveTab(): void {
        if (!this.bcitiTabs?.tabs) return;
        const tabs = this.bcitiTabs.tabs.toArray();
        const activeIndex = tabs.findIndex((t) => t.active);
        if (activeIndex !== this.lastActiveTabIndex) {
            this.lastActiveTabIndex = activeIndex;
            if (activeIndex === 1) {
                this.messagesTabActivated.emit();
            } else {
                this.infosTabActivated.emit();
            }
        }
    }

    onInfoUpdated(updatedRequest: Request): void {
        this.requestChanged.emit(updatedRequest);
    }
}
